import styled from 'styled-components'

export const BoxStars = styled.div`
    display: flex;
    flex-direction: row!important;

    svg {
        color: #ffb800;
        font-size: 0.9rem;
    }
`